import { makeid } from '../../modules/_makeid'

export default function AdOrderTemplate () {
  return {
    status: 'draft',
    token: makeid(),
    price: 0,
    weeks: 1,
    image: null,
    cities: [],
    contact: {},
    payment: {}
  }
}